export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const MOVE_TO_CART_FROM_WISHLIST = "MOVE_TO_CART_FROM_WISHLIST";
export const MOVE_TO_WISHLIST_FROM_CART = "MOVE_TO_WISHLIST_FROM_CART";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const ADD_TO_CART = "ADD_TO_CART";
export const INCREASE_ITEM_IN_WISHLIST = "INCREASE_ITEM_IN_WISHLIST";
export const DECREASE_ITEM_IN_WISHLIST = "DECREASE_ITEM_IN_WISHLIST";
export const INCREASE_ITEM_IN_CART = "INCREASE_ITEM_IN_CART";
export const DECREASE_ITEM_IN_CART = "DECREASE_ITEM_IN_CART";
export const SET_PRODUCTS_DATA = "SET_PRODUCTS_DATA";
export const SET_WISHLIST_DATA = "SET_WISHLIST_DATA";
export const SET_CART_DATA = "SET_CART_DATA";
export const SET_CATEGORIES_DATA = "SET_CATEGORIES_DATA";
